<div class="anuncio anuncio--face-trace">
  <div class="anuncio__header">
    <div class="header-text">
      <div class="header-title">Historia de foto y entrenamiento para reconocimiento facial</div>
      <div class="header-subtitle" *ngIf="data.employeeName">{{data.employeeName}}</div>
    </div>
    <button class="btn-close" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="anuncio__body">
    <div class="grid-container">
      
      <!-- LADO IZQUIERDO: Lista de versiones de foto -->
      <div class="left-pane">
         <div class="pane-title">VERSIONES DE LA FOTO</div>
         
         <div class="loading" *ngIf="loadingPhotos">Cargando fotos...</div>
         
         <div class="photo-versions-list" *ngIf="!loadingPhotos">
            <div class="photo-version-card" 
                 *ngFor="let p of photos"
                 [class.selected]="selectedPhotoId === p.Id"
                 [class.deleted]="p.IsDeleted"
                 (click)="selectPhoto(p)">
               
               <div class="pv-icon">
                 <mat-icon>person_outline</mat-icon>
               </div>
               
               <div class="pv-info">
                 <div class="pv-date-badge">
                   <span class="date">{{ formatDateOnly(p.UploadedAt) }}</span>
                   <span class="badge badge-active" *ngIf="p.IsCurrent">ACTIVA</span>
                   <span class="badge badge-historical" *ngIf="!p.IsCurrent && !p.IsDeleted">HISTÓRICA</span>
                   <span class="badge badge-deleted" *ngIf="p.IsDeleted">BORRADA</span>
                 </div>
                 
                 <div class="pv-uploader">
                   <span *ngIf="!p.IsDeleted">Carga {{ p.Source === 'UpdatePhoto' ? 'web' : 'app' }}<br></span>
                   <span *ngIf="p.IsDeleted">Borrada el {{ formatDateOnly(p.DeletedAt || '') }}<br></span>
                   {{ p.UploadedByUserName || p.UploadedByUserId || 'Sistema' }}
                 </div>
               </div>
               
               <!-- Delete Button -->
               <div class="pv-actions" *ngIf="!p.IsDeleted && data.permissions.canDelete">
                 <button mat-icon-button class="btn-delete" (click)="deletePhoto(p); $event.stopPropagation()">
                    <mat-icon>delete</mat-icon>
                 </button>
               </div>
               
            </div>
         </div>
      </div>

      <!-- LADO DERECHO: Foto activa/seleccionada y Trazabilidad -->
      <div class="right-pane">
        
        <ng-container *ngIf="photos.length > 0; else noPhotos">
          <ng-container *ngIf="true">
            <!-- Buscar la foto seleccionada, o la primera si no hay selección -->
            <ng-container *ngIf="getSelectedPhoto() as p">
              <div class="selected-photo-info">
                <div class="photo-thumbnail">
                 <!-- The Url expires in 5 mins so it should be used directly. ExistsInS3 checks if it's broken. -->
                 <img *ngIf="p.ExistsInS3 && p.Url" [src]="p.Url" alt="Foto">
                 <div class="no-image" *ngIf="!p.ExistsInS3 || !p.Url">Imagen no disponible</div>
              </div>
              <div class="photo-details">
                 <div class="photo-date">
                   Foto del {{ formatDateOnly(p.UploadedAt) }}
                   <span class="badge badge-active" *ngIf="p.IsCurrent">ACTIVA</span>
                   <span class="badge badge-historical" *ngIf="!p.IsCurrent">HISTÓRICA</span>
                 </div>
                 <div class="photo-meta">
                   <div>CARGADA POR</div>
                   <div class="value">{{ p.UploadedByUserName || p.UploadedByUserId || 'Sistema' }}</div>
                 </div>
                 <div class="photo-meta mt-1">
                   <div>ARCHIVO</div>
                   <div class="value">
                     {{ p.OriginalFileName || 'Desconocido' }} · {{ formatBytes(p.FileSizeBytes) }} · {{ p.Width || '-' }}x{{ p.Height || '-' }}
                   </div>
                 </div>
              </div>
              </div>
              <!-- Detalle técnico de validación -->
              <div class="face-validation-section" *ngIf="!loadingValidation && faceValidation">

                <!-- Bloque de Validación -->
                <div *ngIf="faceValidation.Validation" class="validation-block" style="margin-top: 20px;">
                  
                  <div class="block-header-validation" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                    <span class="block-name" style="font-size: 15px; font-weight: 600; color: #333;">Validación al subir</span>
                    <span style="font-size: 12px; color: #666; font-weight: 500;">Notas: <strong>{{ faceValidation?.Validation?.PhotoValidationMode || 'Observe' }}</strong></span>
                  </div>

                  <table *ngIf="faceValidation.Validation.Rules && faceValidation.Validation.Rules.length > 0" class="metrics-table grouped-table">
                        <thead>
                          <tr class="header-columns-row">
                            <th class="th-rule">PRÁCTICA</th>
                            <th class="th-expected">ESPERADO</th>
                            <th class="th-obtained">OBTENIDO</th>
                            <th class="th-status">ESTADO</th>
                          </tr>
                        </thead>
                    <tbody>
                      <ng-container *ngFor="let group of groupRulesByCategory(faceValidation.Validation.Rules)">
                        <tr class="section-header" [style.borderLeftColor]="getCategoryColor(group.category)">
                          <td colspan="4" class="section-title">
                            <span class="section-icon" [ngSwitch]="group.category.toUpperCase()">
                              <mat-icon *ngSwitchCase="'ENCUADRE'">crop_square</mat-icon>
                              <mat-icon *ngSwitchCase="'POSICIÓN DEL ROSTRO'">portrait</mat-icon>
                              <mat-icon *ngSwitchCase="'POSICIÓN'">portrait</mat-icon>
                              <mat-icon *ngSwitchDefault>image</mat-icon>
                            </span>
                            {{ group.category | uppercase }}
                          </td>
                        </tr>
                        <tr *ngFor="let rule of group.rules" [class.passed]="rule.Passed === true" [class.failed]="rule.Passed === false" [class.pending]="rule.Passed === null">
                          <td class="col-rule" [title]="rule.Description || ''">
                            <div class="rule-info-wrapper"
                                 [matTooltip]="rule.Description"
                                 matTooltipPosition="above"
                                 [matTooltipShowDelay]="0"
                                 matTooltipClass="rule-description-tooltip">
                              <span class="rule-name">{{ rule.Label || rule.Name }}</span>
                              <mat-icon *ngIf="rule.Description" class="rule-info-icon">info_outline</mat-icon>
                            </div>
                          </td>
                          <td class="col-metric col-expected">{{ rule.Limit || rule.LimitText || '-' }}</td>
                          <td class="col-metric col-obtained">{{ rule.ValueText !== null && rule.ValueText !== undefined && rule.ValueText !== '' ? rule.ValueText : (rule.Value !== null && rule.Value !== undefined ? rule.Value : '-') }}</td>
                          <td class="col-status">
                            <ng-container *ngIf="rule.Passed === true">
                              <mat-icon class="icon-cumple">check_circle</mat-icon>
                              <span class="status-text cumple">CUMPLE</span>
                            </ng-container>
                            <ng-container *ngIf="rule.Passed === false">
                              <mat-icon class="icon-error">error</mat-icon>
                              <span class="status-text error">NO CUMPLE</span>
                            </ng-container>
                            <ng-container *ngIf="rule.Passed === null">
                              <span class="status-text pending">—</span>
                            </ng-container>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="loading" *ngIf="loadingValidation">Cargando detalle técnico...</div>


              <!-- Trazabilidad del reconocimiento facial -->
              <div class="summary-title" *ngIf="!loadingSummary && !loadingValidation && (faceSummary || faceValidation)" style="font-size: 13px; font-weight: 600; color: #333; margin-top: 20px; display: flex; align-items: center;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 5px;">timeline</mat-icon>
    TRAZABILIDAD <span *ngIf="p.UploadedAt" style="margin-left: 5px;">: {{ p.UploadedAt | date:'dd/MM/yyyy' }}</span>
  </div>

              
              <!-- Lista del Proceso (items verticales completos) -->
              <div class="process-list-section" *ngIf="!loadingSummary && faceSummary">
                

                <div *ngIf="faceSummary.items && faceSummary.items.length > 0" class="process-items">
                  <div *ngFor="let item of faceSummary.items" class="process-item" [class.success]="item.IsSuccess === true" [class.error]="item.IsSuccess === false" [class.pending]="item.IsSuccess === null">
                    <div class="process-header">
                      <mat-icon class="process-icon" [ngSwitch]="item.IsSuccess">
                        <span *ngSwitchCase="true">check_circle</span>
                        <span *ngSwitchCase="false">error</span>
                        <span *ngSwitchDefault>schedule</span>
                      </mat-icon>
                      <div class="process-title-text">{{ item.Title }}</div>
                    </div>
                    <div class="process-description">{{ item.Description }}</div>
                  </div>
                </div>
                <div *ngIf="!faceSummary.items || faceSummary.items.length === 0" class="no-info">Sin información de validación</div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #noPhotos>
           <div class="no-photos-msg">
             Aún no hay fotos registradas para esta persona.
           </div>
        </ng-template>
      </div>

    </div>
  </div>

  <div class="anuncio__actions">
    <div>
      <button mat-flat-button class="btn-confirm" 
              *ngIf="data.permissions.canReprocess"
              (click)="reprocessPhoto()">
        <mat-icon style="margin-right: 5px; font-size: 18px; width: 18px; height: 18px;">sync</mat-icon>
        Reentrenar reconocimiento
      </button>
    </div>

    <div style="margin-left: auto;">
      <button mat-stroked-button class="btn-cancel" (click)="onClose()">
        Cerrar
      </button>
    </div>
  </div>
</div>
